/**
 * @desc undefined
 */
import { PreviewContentParam } from '@eastcoal/api/contract/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type PreviewContentParameter = PreviewContentParam

const method = 'POST'
const url = '/contract/templateEngine/preview'

export const previewContentApi = (
  data?: PreviewContentParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<string>({
    method,
    url,
    data,
    ...config
  })
}

previewContentApi.method = method
previewContentApi.url = url
